import arrayMutators from 'final-form-arrays'
import { Button } from 'primereact/button'
import { Checkbox } from "primereact/checkbox"
import { Chips } from "primereact/chips"
import { Dropdown } from "primereact/dropdown"
import { Fieldset } from 'primereact/fieldset'
import { InputText } from "primereact/inputtext"
import { Tooltip } from 'primereact/tooltip'
import { classNames } from "primereact/utils"
import { useState } from 'react'
import { Field, Form } from "react-final-form"
import { FieldArray } from 'react-final-form-arrays'
import { AmazonLexInbuiltSlotType, Branch, ConditionalQuestion, ConditionArithmeticOperatorEnum, ConditionEnum, ConditionQuantifierOperatorEnum, ConfirmationSetting, ExpressionQuery, IntentDetails, InterviewNode, QuestionType } from "../../../../../../CandidatePortal/scenes/Interview/Chatbot/interface"

import OnChange from "../../../../../../utils/OnChange"
import styles from "../styles.module.css"
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../../../../store'
import { InputNumber } from 'primereact/inputnumber'

interface ConditionalFormProps {
  actionOnSubmit: any
  actionOnDelete: any
  intentNode: ConditionalQuestion
  intentNameList?: string[]
  firstNode: InterviewNode
  lastNode: InterviewNode
  isUpdate?: boolean
  autosave: boolean
  onQuestionTypeChange: (newQuestionType: any) => void
}

const ConditionalForm = (props: ConditionalFormProps) => {
  const dispatch = useDispatch<AppDispatch>()
  const { actionOnSubmit, actionOnDelete, intentNode, firstNode, lastNode, intentNameList, isUpdate = false, autosave, onQuestionTypeChange } = props

  const allSlotKeys = Object.keys(AmazonLexInbuiltSlotType) as string[]
  const allSlotValues = Object.values(AmazonLexInbuiltSlotType) as string[]
  const allTenantSlotTypeOptions = [
    {
      label: "Default Types",
      items: allSlotKeys.map((value: string, index: number) => {
        return { label: value, value: allSlotValues[index] }
      })
    }
  ]
  
  const allConditionArithmeticOperatorKeys = Object.keys(ConditionArithmeticOperatorEnum) as string[]
  const allConditionArithmeticOperatorValues = Object.values(ConditionArithmeticOperatorEnum) as string[]
  const allConditionQuantifierOperatorKeys = Object.keys(ConditionQuantifierOperatorEnum) as string[]
  const allConditionQuantifierOperatorValues = Object.values(ConditionQuantifierOperatorEnum) as string[]
  const operatorTypeOptions = [
    {
      label: "Arithmetic Operators",
      items: allConditionArithmeticOperatorKeys.map((value: string, index: number) => {
        return { label: value, value: allConditionArithmeticOperatorValues[index] }
      })
    },
    {
      label: "Quantifier Operators",
      items: allConditionQuantifierOperatorKeys.map((value: string, index: number) => {
        return { label: value, value: allConditionQuantifierOperatorValues[index] }
      })
    }
  ]

  // const operatorOptions = [
  //   {
  //     label: "Comparison Operators",
  //     items: [
  //       { label: "Equals", value: "=" },
  //       { label: "Not equals", value: "!=" },
  //       { label: "Less than", value: "<" },
  //       { label: "Less than or equals", value: "<=" },
  //       { label: "Greater than", value: ">" },
  //       { label: "Greater than or equals", value: ">=" }
  //     ]
  //   },
  //   {
  //     label: "Quantifier Operator",
  //     items: [
  //       { label: "Contains", value: "CONTAINS" }
  //     ]
  //   }
  // ]

  const groupedItemTemplate = (option: any) => {
    return (
      <div className="text-lg font-bold text-blue-600">{option.label}</div>
    );
  }

  //Mutating initialValues from enum value (for backend use) to enum key representation for dropdown options UI
  let initialValues: ConditionalQuestion = !!intentNode ? { ...intentNode, } : {} as ConditionalQuestion

  const validate = (data: any) => {
    let errors = {} as any

    if (!data.typeOfQuestion) {
      errors.typeOfQuestion = 'The type of question must be specified'
    }

    if (!data.name) {
      errors.name = 'Please specify the name of the node'
    } else if (!isUpdate && data.name) {
      if (intentNameList && intentNameList.length > 0 && intentNameList.find(element => element === data.name) !== undefined) {
        errors.name = 'This name is currently in use by another node'
      }
    }

    //Validation for only allowing 1 first and 1 last node
    if (data.isFirstQuestion && Object.keys(firstNode).length !== 0 && !initialValues.isFirstQuestion)
      errors.isFirstQuestion = "First node already exists"
    if (data.isLastQuestion && Object.keys(lastNode).length !== 0 && !initialValues.isLastQuestion)
      errors.isLastQuestion = "Last node already exists"


    if (!data.slotType) {
      errors.slotType = 'Please select a slot type'
    }

    if (data.slotPrompt === undefined || data.slotPrompt.length === 0) {
      errors.slotPrompt = "Please input the prompt."
    }

    if (data.conditionalSetting?.branches === undefined || data.conditionalSetting?.branches.length === 0) {
      errors.branchesText = "Please create at least one branch."
    }
    else {
      data.conditionalSetting.branches.forEach((branch: any, index: number) => {
        if (!branch.expression)
          errors.branchesText = "Please include at least 1 expression for " + branch.name
      })
    }

    return errors;
  }

  const onSubmit = (data: any, form: any) => {
    let payload = structuredClone(data) as InterviewNode
    
    payload.position = data.position ? data.position : { x: 0, y: 0 }
    // payload.chips = chips
    // payload.position = data.position ? data.position : { x: 0, y: 0 }
    if (payload.typeOfQuestion === QuestionType.ConditionalQuestion) { //Type narrowing
      // if (payload.scoreIfUnfulfilled === undefined)
      //   payload.scoreIfUnfulfilled = 0; //Programmatically mutating score to 0 if user left InputText field blank
      // else
      //   payload.scoreIfUnfulfilled = +payload.scoreIfUnfulfilled; //Parse InputText component from string to number type
      // if (payload.scoreIfFulfilled === undefined)
      //   payload.scoreIfFulfilled = 0;
      // else
      //   payload.scoreIfFulfilled = +payload.scoreIfFulfilled;

      // if (!payload.validateCandidateInput) {
      //   payload.confirmationSetting = {} as ConfirmationSetting
      // } else {
      //   payload.slotElicitationSetting.successResponse = []
      // }
    }
    console.log({ payload })
    dispatch(actionOnSubmit(payload, autosave))

    // setChips([])
    form.restart()
  }

  const deleteNode = (form: any) => {
    dispatch(actionOnDelete(initialValues, autosave))
    form.restart()
  }

  const getExcludedNameList = (values: any) => {
    if (!!values) {
      let tempIntentNameList = intentNameList?.slice(0)
      if (tempIntentNameList) {
        let valueIndex = tempIntentNameList.indexOf(values)
        if (valueIndex !== -1)
          tempIntentNameList.splice(valueIndex, 1)
      }
      return tempIntentNameList
    }
    return intentNameList
  }

  const required = (value: any) => value ? undefined : 'This is a required field'

  const checkForDuplicate = (value: string[]) => {
    if (value && value.length > 0) {
      let tempArr = value.map(element => element.toLowerCase())
      if (new Set(tempArr).size !== value.length)
        return 'Please check if there are any duplicated chip values';
      return undefined;
    }
    return undefined;
  }

  const isFormFieldValid = (meta: any) => !!((meta.touched || meta.modified) && meta.error)

  const getFormErrorMessage = (meta: any) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>
  }

  const WhenLastQuestionIsChecked = ({ set, to }: { set: string, to: any }) => {
    return (
      <Field name={set} subscription={{}}>
        {(
          // No subscription. We only use Field to get to the change function
          { input: { onChange } }
        ) => {
          return (
            <OnChange name='isLastQuestion'>
              {(value: boolean) => {
                if (value === true) {
                  onChange(to);
                }
              }}
            </OnChange>
          )
        }}
      </Field>
    )
  }

  return (
    <div>
      <h3>{isUpdate ? "Update new Conditional node" : "Create new Conditional node"}</h3>
      <p className="text-sm font-italic font-normal line-height-3 text-500 hover:text-700">
        A Conditional node is intended to capture a candidate's response, subsequently interpreted through a condition to be fulfilled before
        flowing to the next node.
        <br></br>
        Such as a conditional node asking "How many years of working experience do you have?" with a condition set to check for &gt;= 3 years,
        <br></br>
        would flow the conversation to the unfulfilled path if candidate were to respond correspondingly.
      </p>
      <Form onSubmit={onSubmit} mutators={{ ...arrayMutators }} initialValues={initialValues} validate={validate} render={({ form: { mutators: { push, pop, remove } }, form, values, handleSubmit, pristine }) => (
        <form onSubmit={handleSubmit}>
          {/* <WhenLastQuestionIsChecked set="flowToIfUnfulfilled" to={undefined} /> */}
          {/* <WhenLastQuestionIsChecked set="flowToIfFulfilled" to={undefined} /> */}
          {/* <WhenLastQuestionIsChecked set="messageIfUnfulfilled" to={undefined} /> */}
          {/* <WhenLastQuestionIsChecked set="messageIfFulfilled" to={undefined} /> */}
          {/* <WhenLastQuestionIsChecked set="scoreIfUnfulfilled" to={0} /> */}
          {/* <WhenLastQuestionIsChecked set="scoreIfFulfilled" to={0} /> */}
          {/* <WhenLastQuestionIsChecked set="" to={undefined} /> */}
          <Fieldset className={styles.nodeform} legend="Node Details" toggleable>
            <div className="formgrid grid">
              <Field name="typeOfQuestion" render={({ input, meta }) => (
                <div className="field col-6 md:col-6">
                  <label htmlFor="typeOfQuestionInput" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Type of Question*</label>
                  <Dropdown id="typeOfQuestionInput" {...input} disabled={isUpdate} options={Object.values(QuestionType)} onChange={onQuestionTypeChange} className={classNames("inputfield w-full", { 'p-invalid': isFormFieldValid(meta) })} />
                  {getFormErrorMessage(meta)}
                </div>
              )} />
              <Field name="name" render={({ input, meta }) => (
                <div className="field col-6 md:col-6">
                  <label htmlFor="nameInput" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Name of Node*</label>
                  <InputText id="nameInput" autoComplete="off" {...input} inputMode="text" className={classNames("inputfield w-full", { 'p-invalid': isFormFieldValid(meta) })} keyfilter="alphanum" />
                  {getFormErrorMessage(meta)}
                </div>
              )} />
              <Field name="isFirstQuestion" type="checkbox" render={({ input, meta }) => (
                <div className="field-checkbox field col-12 md:col-6">
                  <Checkbox inputId="isFirstQuestionInput" {...input} checked={input.checked || false} />
                  <label htmlFor="isFirstQuestionInput">Is this node the first question of the interview?</label>
                  {getFormErrorMessage(meta)}
                </div>
              )} />
              <Field name="isLastQuestion" type="checkbox" render={({ input, meta }) => (
                <div className="field-checkbox field col-12 md:col-6">
                  <Checkbox inputId="isLastQuestionInput" {...input} checked={input.checked || false} />
                  <label htmlFor="isLastQuestionInput">Is this node the last question of the interview?</label>
                  {getFormErrorMessage(meta)}
                </div>
              )} />
            </div>
          </Fieldset>

          <Fieldset className={styles.nodeform} legend="Elicitation Settings" toggleable>
            <div className="formgrid grid">
              <Field name="slotPrompt" render={({ input, meta }) => (
                <div className="field col-12">
                  <label htmlFor="slotPromptInput" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Slot Prompt*</label>
                  <InputText id="slotPromptInput" {...input} inputMode="text" className={classNames("inputfield w-full", { 'p-invalid': isFormFieldValid(meta) })} />
                  {getFormErrorMessage(meta)}
                </div>
              )} />
              <Field name="slotType" render={({ input, meta }) => (
                <div className="field col-7">
                  <label htmlFor="slotTypeInput" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Slot Type*</label>
                  <Dropdown id="slotTypeInput" {...input} options={allTenantSlotTypeOptions} className={classNames("inputfield w-full", { 'p-invalid': isFormFieldValid(meta) })} optionGroupChildren="items" optionGroupLabel="label" optionGroupTemplate={groupedItemTemplate} />
                  {getFormErrorMessage(meta)}
                </div>
              )} />
            </div>
          </Fieldset>

          <Fieldset className={styles.nodeform} legend="Default Branch" toggleable>
            <div className="formgrid grid">
              <p className="text-sm font-italic font-normal line-height-3 text-500 hover:text-700">The default response given by the bot if user answer does not meet any of the set conditions.</p>
              <Field name="conditionalSetting.defaultStep" render={({ input, meta }) => (
                <>
                  <div className="field col-6">
                    <label htmlFor="defaultStepInput" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Default Step</label>
                    <Dropdown id="defaultStepInput" showClear disabled={values.isLastQuestion} tooltip="The default step when no conditions are matched" {...input} options={!!intentNameList ? getExcludedNameList(values.name) : []} className="inputfield w-full" />
                    {getFormErrorMessage(meta)}
                  </div><Field name="conditionalSetting.defaultBranchScore" render={({ input }) => (
                    <div className="field col-6">
                      <label htmlFor="defaultBranchScoreInput">Default Branch Score</label>
                      <InputNumber id="defaultBranchScoreInput" min={0} max={5} tooltip="The score to be given for the candidate for fulfilling this branch condition" {...input} className="inputfield w-full" />
                    </div>
                  )} />
                  <div className="col-4">
                    <Button id="addDefaultBranchResponseBtn" label="Add Response" type="button" icon="pi pi-plus" iconPos="right" disabled={!!(values.conditionalSetting && values.conditionalSetting.defaultBranchResponse && values.conditionalSetting.defaultBranchResponse.length >= 3)} onClick={() => push('conditionalSetting.defaultBranchResponse', "")}></Button>
                  </div>
                </>
              )} />

            </div>
          </Fieldset>

          <Fieldset className={styles.nodeform} legend="Branch Settings" toggleable>
            <div className="formgrid grid">
              <p className="text-sm font-italic font-normal line-height-3 text-500 hover:text-700">Branching responses to user inputs. Please create at least one.</p>
              <Field name="branchesText" render={({ input, meta }) => (
                <div className="field col-7">
                  <label htmlFor="branchesText" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Branches</label>
                  <div />
                  {getFormErrorMessage(meta)}
                </div>
              )} />
              <div className="field col-12">
                <Button label="Add Branch" type="button" icon="pi pi-plus" iconPos="right" disabled={!!(values.conditionalSetting && values.conditionalSetting.branches && values.conditionalSetting.branches.length >= 3)} onClick={() => push('conditionalSetting.branches', {} as Branch)}></Button>
              </div>
              <FieldArray name="conditionalSetting.branches">
                {({ fields }) =>
                  fields.map((branch, branchIndex) => (
                    <Fieldset className={`${styles.nodeform} fadeinleft animation-duration-500 animation-iteration-1`} key={`branch${(branchIndex + 1).toString()}`} legend={`Branch ${branchIndex + 1}`} toggleable>
                      <div className="formgrid grid">
                        <div className="col-12 text-right">
                          <Button className="p-button-danger p-button-outlined" label="Remove Branch" type="button" icon="pi pi-minus" iconPos="right" onClick={() => remove('conditionalSetting.branches', branchIndex)}></Button>
                        </div>
                        <Field name={`${branch}.name`} validate={required} render={({ input, meta }) => (
                          <div className="field col-6">
                            <label htmlFor="branchNameInput" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Name of Branch*</label>
                            <InputText id="branchNameInput" autoComplete="off" {...input} inputMode="text" className={classNames("inputfield w-full", { 'p-invalid': isFormFieldValid(meta) })} keyfilter="alphanum" />
                            {getFormErrorMessage(meta)}
                          </div>
                        )} />
                        <Field name={`${branch}.nextStep`} render={({ input }) => (
                          <div className="field col-12 md:col-6">
                            <label htmlFor="branchNextStepInput">Next Step</label>
                            <Dropdown id="branchNextStepInput" showClear disabled={values.isLastQuestion} tooltip="The next node to flow to if the condition of this node is fulfilled" {...input} options={!!intentNameList ? getExcludedNameList(values.name) : []} className="inputfield w-full" />
                          </div>
                        )} />
                        <WhenLastQuestionIsChecked set={`${branch}.nextStep`} to={undefined} />
                        <Field name={`${branch}.branchScore`} render={({ input }) => (
                          <div className="field col-12 md:col-6">
                            <label htmlFor="branchScoreInput">Score</label>
                            <InputNumber id="branchScoreInput" min={0} max={5} tooltip="The score to be given for the candidate for fulfilling this branch condition" {...input} className="inputfield w-full" />
                          </div>
                        )} />
                        
                        <div className="field col-12 md:col-12">
                          <Button className="text-xs p-button-outlined" label="New Expression" type="button" onClick={() => push(`${branch}.expression.queries`, {} as ExpressionQuery)}></Button>
                          {/* <Button className="text-xs p-button-outlined mr-2" label="AND" type="button" disabled={false} onClick={() => push(`${branch}.expression`, { condition: ConditionEnum.AND } as Expression)}></Button> */}
                          {/* <Button className="text-xs p-button-outlined" label="OR" type="button" disabled={false} onClick={() => push(`${branch}.expression`, { condition: ConditionEnum.OR } as Expression)}></Button> */}
                        </div>
                        <Field name={`${branch}.expression.condition`} render={({ input }) => (
                          <div className="field col-12">
                            <label htmlFor="expressionConditionInput">Expression Condition</label>
                            <Dropdown id="expressionConditionInput" tooltip="The conditional expression conjoining each expression query statement" {...input} options={Object.keys(ConditionEnum)} className="inputfield w-full" />
                          </div>
                        )} />
                        <FieldArray name={`${branch}.expression.queries`}>
                          {({ fields }) =>
                            fields.map((expressionQuery, expressionIndex) => (
                              <div className="fadeinleft animation-duration-500 animation-iteration-1 col-12 formgrid grid" key={`expressionQuery${(expressionIndex + 1).toString()}`}>
                                <h4 className="col-12">Expression Query: {expressionIndex + 1}</h4>
                                {/* {expressionIndex !== 0 ?
                              <Field name={`${expression}.condition`} validate={required} render={({ input, meta }) => (
                                <div className="field col-4">
                                  <label htmlFor="conditionInput" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Condition*</label>
                                  <Dropdown id="conditionInput" tooltip="The conditional expression conjoining each expression query statement" {...input} options={Object.keys(ConditionEnum)} className="inputfield w-full" />
                                  {getFormErrorMessage(meta)}
                                </div>
                              )} />
                              : <></>} */}
                                <Field name={`${expressionQuery}.conditionOperator`} validate={required} render={({ input, meta }) => (
                                  <div className="field col-4">
                                    <label htmlFor="expressionQueryConditionOperatorInput" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Operand*</label>
                                    <Dropdown id="expressionQueryConditionOperatorInput" tooltip="The conditional operator used for this expression" {...input} options={operatorTypeOptions} className="inputfield w-full" optionGroupChildren="items" optionGroupLabel="label" optionGroupTemplate={groupedItemTemplate} />
                                    {getFormErrorMessage(meta)}
                                  </div>
                                )} />
                                <Field name={`${expressionQuery}.value`} validate={required} render={({ input, meta }) => (
                                  <div className="field col-3">
                                    <label htmlFor="expressionQueryValueInput" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Value*</label>
                                    <InputText id="expressionQueryValueInput" autoComplete="off" {...input} inputMode="text" className={classNames("inputfield w-full", { 'p-invalid': isFormFieldValid(meta) })} />
                                    {getFormErrorMessage(meta)}
                                  </div>
                                )} />
                                <div>
                                  <Button className="p-button-danger p-button-outlined" type="button" icon="pi pi-times" onClick={() => remove(`${branch}.expression`, expressionIndex)}></Button>
                                </div>
                              </div>
                            ))}

                        </FieldArray>
                      </div>
                    </Fieldset>
                  ))
                }
              </FieldArray>
            </div>
          </Fieldset>
          <div className="flex justify-content-end align-items-end mt-2">
            <Button type="button" className="p-button-outlined p-button-danger mr-3" label="Delete" icon="pi pi-trash" onClick={() => deleteNode(form)} disabled={!isUpdate}></Button>
            <Button type="submit" label={isUpdate ? "Update" : "Create"} icon="pi pi-check" disabled={pristine}></Button>
          </div>
        </form >
      )
      } />
    </div >
  )
}

export default ConditionalForm